import image1 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image1.webp";
import image2 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image2.webp";
import image4 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image4.webp";
import image7 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image7.webp";
import image8 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image8.webp";
import image9 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image9.webp";
import image10 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image10.webp";
import image11 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image11.webp";
import image12 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image12.webp";
import image13 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image13.webp";
import image15 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image15.webp";
import image16 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image16.webp";
import image17 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image17.webp";
import image18 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image18.webp";
import image20 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image20.webp";
import image21 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image21.webp";
import image22 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image22.webp";
import image23 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image23.webp";
import image24 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image24.webp";
import image25 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image25.webp";
import image26 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image26.webp";
import image27 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image27.webp";
import image28 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image28.webp";
import image29 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image29.webp";
import image31 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image31.webp";
import image32 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image32.webp";
import image33 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image33.webp";
import image35 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image35.webp";
import image36 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image36.webp";
import image37 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image37.webp";
import image38 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image38.webp";
import image39 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image39.webp";
import image42 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image42.webp";
import image43 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image43.webp";
import image44 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image44.webp";
import image45 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image45.webp";
import image46 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image46.webp";
import image48 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image48.webp";
import image50 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image50.webp";
import image51 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image51.webp";
import image52 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image52.webp";
import image53 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image53.webp";
import image54 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image54.webp";
import image55 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image55.webp";
import image57 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image57.webp";
import image59 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image59.webp";
import image62 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image62.webp";
import image64 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image64.webp";
import image73 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image73.webp";
import image74 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image74.webp";
import image75 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image75.webp";
import image76 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image76.webp";
import image77 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image77.webp";
import image79 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image79.webp";
import image80 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image80.webp";
import image81 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image81.webp";
import image82 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image82.webp";
import image84 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image84.webp";
import image85 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image85.webp";
import image86 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image86.webp";
import image87 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image87.webp";
import image88 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image88.webp";
import image89 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image89.webp";
import image91 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image91.webp";
import image92 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image92.webp";
import image93 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image93.webp";
import image94 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image94.webp";
import image95 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image95.webp";
import image96 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image96.webp";
import image97 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image97.webp";
import image98 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image98.webp";
import image99 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image99.webp";
import image100 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image100.webp";
import image101 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image101.webp";
import image102 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image102.webp";
import image103 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image103.webp";
import image104 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image104.webp";
import image105 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image105.webp";
import image106 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image106.webp";
import image107 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image107.webp";
import image108 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image108.webp";
import image109 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image109.webp";
import image110 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image110.webp";
import image111 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image111.webp";
import image112 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image112.webp";
import image113 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image113.webp";
import image114 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image114.webp";
import image115 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image115.webp";
import image116 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image116.webp";
import image117 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image117.webp";
import image118 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image118.webp";
import image119 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image119.webp";
import image121 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image121.webp";
import image122 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image122.webp";
import image123 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image123.webp";
import image125 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image125.webp";
import image126 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image126.webp";
import image129 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image129.webp";
import image130 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image130.webp";
import image131 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image131.webp";
import image133 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image133.webp";
import image134 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image134.webp";
import image135 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image135.webp";
import image136 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image136.webp";
import image137 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image137.webp";
import image138 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image138.webp";
import image139 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image139.webp";
import image140 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image140.webp";
import image141 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image141.webp";
import image142 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image142.webp";
import image143 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image143.webp";
import image144 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image144.webp";
import image145 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image145.webp";
import image146 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image146.webp";
import image147 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image147.webp";
import image148 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image148.webp";
import image149 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image149.webp";
import image150 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image150.webp";
import image151 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image151.webp";
import image152 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image152.webp";
import image153 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image153.webp";
import image154 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image154.webp";
import image158 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image158.webp";
import image159 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image159.webp";
import image160 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image160.webp";
import image163 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image163.webp";
import image165 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image165.webp";
import image166 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image166.webp";
import image167 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image167.webp";
import image168 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image168.webp";
import image169 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image169.webp";
import image170 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image170.webp";
import image171 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image171.webp";
import image172 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image172.webp";
import image173 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image173.webp";
import image174 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image174.webp";
import image175 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image175.webp";
import image176 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image176.webp";
import image177 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image177.webp";
import image178 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image178.webp";
import image179 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image179.webp";
import image180 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image180.webp";
import image181 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image181.webp";
import image182 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image182.webp";
import image183 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image183.webp";
import image184 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image184.webp";
import image185 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image185.webp";
import image186 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image186.webp";
import image187 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image187.webp";
import image188 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image188.webp";
import image189 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image189.webp";
import image190 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image190.webp";
import image191 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image191.webp";
import image192 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image192.webp";
import image193 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image193.webp";
import image194 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image194.webp";
import image195 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image195.webp";
import image196 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image196.webp";
import image197 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image197.webp";
import image198 from "../../../../../assets/Images/Highlights/LanguageDept/2023-2024/Image198.webp";


export const yearTwentyTwentyThreeFour = [
  image1,
  image2,
  image45,
  image4,
  image23,
  image11,
  image7,
  image8,
  image9,
  image10,
  image12,
  image13,
  image15,
  image16,
  image17,
  image18,
  image20,
  image21,
  image22,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image31,
  image32,
  image33,
  image35,
  image36,
  image37,
  image38,
  image39,
  image42,
  image43,
  image44,
  image46,
  image48,
  image50,
  image51,
  image52,
  image53,
  image54,
  image55,
  image57,
  image59,
  image64,
  image62,
  image76,
  image77,
  image80,
  image84,
  image73,
  image74,
  image79,
  image81,
  image82,
  image102,
  image75,
  image85,
  image86,
  image87,
  image88,
  image89,
  image91,
  image92,
  image93,
  image94,
  image95,
  image96,
  image97,
  image98,
  image99,
  image100,
  image101,
  image103,
  image104,
  image105,
  image106,
  image107,
  image108,
  image109,
  image110,
  image111,
  image112,
  image113,
  image114,
  image115,
  image119,
  image116,
  image117,
  image125,
  image118,
  image121,
  image122,
  image123,
  image126,
  image129,
  image130,
  image147,
  image131,
  image133,
  image134,
  image135,
  image136,
  image137,
  image138,
  image139,
  image140,
  image141,
  image142,
  image143,
  image144,
  image145,
  image146,
  image151,
  image148,
  image149,
  image150,
  image152,
  image153,
  image158,
  image154,
  image159,
  image160,
  image163,
  image165,
  image166,
  image167,
  image168,
  image169,
  image170,
  image171,
  image172,
  image173,
  image174,
  image175,
  image176,
  image177,
  image178,
  image179,
  image180,
  image181,
  image182,
  image183,
  image184,
  image185,
  image186,
  image187,
  image188,
  image189,
  image190,
  image191,
  image192,
  image193,
  image194,
  image195,
  image196,
  image197,
  image198,
]
